import "./finanicalPages.css"

export default function FinancialTools() {
    return (
        <section className="home-div">
            <h2>Financial Tools</h2>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" />

            <div className="tools-grid">

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CASimpleLoan.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-chart-line"></i>
                    <h3>Amortizing Loan Calculator</h3>
                    <p>Enter your desired payment and its frequency- and let us calculate your loan amount. Or, enter in the loan amount and we will calculate your loan payment!</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CABreakEven.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-scale-balanced"></i>
                    <h3>Breakeven Analysis Calculator</h3>
                    <p>Find out how many and what price you must sell your product at to make a profit.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CACashFlow.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-arrows-left-right"></i>
                    <h3>Cash Flow Calculator</h3>
                    <p>Having adequate cash flow is essential to keep your business running. Use this calculator to help you determine the cash flow generated by your business.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CACompoundInterest.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-repeat"></i>
                    <h3>Compound Interest Calculator</h3>
                    <p>This calculator demonstrates how compounding can affect your savings.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CAInvestmentDebt.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-layer-group"></i>
                    <h3>Consolidation Loan Investment Calculator</h3>
                    <p>Getting a consolidation loan can do more than payoff your debt. Use this calculator to see the results of paying off your debt and investing your payment savings.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CADebtPayoff2.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-credit-card"></i>
                    <h3>Credit Card Minimum Payment Calculator</h3>
                    <p>Use this calculator to determine how long it will take you to payoff your credit cards if you only make the minimum payments.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CACardOptimizer.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-sliders"></i>
                    <h3>Credit Card Optimizer Calculator</h3>
                    <p>The Credit Card Optimizer helps you determine the best distribution of your credit card debt.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CACreditLine.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-grip-lines"></i>
                    <h3>Credit Line Calculator</h3>
                    <p>How big a line of credit can you receive? Use this calculator to find out!</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CAExistingLoan.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-file-invoice-dollar"></i>
                    <h3>Existing Loan Calculator</h3>
                    <p>Use this calculator to analyze one of your existing loans. Calculate your remaining balance based on the number of monthly payments you have remaining.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CAInvestmentDistribution.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-piggy-bank"></i>
                    <h3>Investment Savings and Distributions Calculator</h3>
                    <p>Use this calculator to see how long your investment savings can last once you begin taking distributions.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CALifeTime.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-heart-pulse"></i>
                    <h3>Life Expectancy Calculator</h3>
                    <p>This calculator can give you an idea of your life expectancy based on your current age, smoking habits, gender and several other important lifestyle choices.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CAPaymentOptions.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-calendar-check"></i>
                    <h3>Line of Credit and Loan Payments Calculator</h3>
                    <p>This calculator helps determine your loan or line of credit payment.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CANetWorth.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-coins"></i>
                    <h3>Net Worth Calculator</h3>
                    <p>This calculator helps you determine your net worth. It also estimates how your net worth could grow (or shrink!) over the next ten years.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CADebtConsolidate.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-link"></i>
                    <h3>Personal Debt Consolidator Calculator</h3>
                    <p>Should you consolidate your debt? This calculator is designed to help determine if debt consolidation is right for you.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CAMortgageRentvsBuy.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-house-circle-check"></i>
                    <h3>Rent vs. Buy Calculator</h3>
                    <p>Are you better off buying your home, or should you continue to rent?</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CARetirementIncome.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-hand-holding-dollar"></i>
                    <h3>Retirement Income Calculator</h3>
                    <p>Use this calculator to determine how much monthly income your retirement savings may provide you in your retirement.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CARetirementNestegg.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-egg"></i>
                    <h3>Retirement Nestegg Calculator</h3>
                    <p>Do you know how much it takes to create a secure retirement? Use this calculator to help determine what size your retirement nestegg should be.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/RRSPLoan.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-seedling"></i>
                    <h3>RRSP Loan Calculator</h3>
                    <p>An RRSP loan can be an excellent way to jump start your retirement savings. Use this calculator to see how an RRSP loan could help your retirement savings plan.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CACompoundSavings.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-vault"></i>
                    <h3>Savings Calculator</h3>
                    <p>Find out how consistent investments over a number of years can be an effective strategy to accumulate wealth.</p>
                </a>

                <a className="tool-card" rel="noopener noreferrer"
                    href="https://www.cchwebsites.com/content/calculators/CASavingsVariables.html?iframe=true&width=100%25&height=100%25"
                    target="_blank">
                    <i className="fa-solid fa-percent"></i>
                    <h3>Savings, Taxes, and Inflation Calculator</h3>
                    <p>Use this calculator to determine how much your savings will be worth with these two important variables in mind.</p>
                </a>
                
            </div>

        </section>
    );
}